export const APP_DICTIONARY: Record<string, string[]> = {
  אהרון: ['ארון'],
  איזוהי: ['איזו היא', 'איזוהי היא'],
  אטפוך: ['התפוך'],
  אלהי: ['אלוקי', 'אלוקיי'],
  "אף הוא": ['אפור', 'עפו'],
  אל: ['על'],
  אלהיו: ['אלוקיו'],
  אלהים: ['אלוקים', 'אלוהים'],
  אפו: ['הפו'],
  בז: ['וז'],
  בטל: ['בת אל'],
  בין: ['בן', 'בין'],
  בכרת: ['בחרט', 'בכרת'],
  ברתותא: ['ברטוטה', 'השברת אותה'],
  בתגא: ['ותג', 'בטגח', 'בטאגה'],
  גלגלת: ['גולגולת'],
  דאטפת: ['דעתך', 'דעת טסט'],
  "ה'": ['אדוני', 'השם'],
  הא: ['הר'],
  הוו: ['הבו', 'הו', 'אבו'],
  הוי: ['הבה', 'הבי', 'הביא', 'הביי'],
  העמלים: ['העמלים'],
  המטהר: ['המתאר'],
  הנדבך: ['הנטבח'],
  וביכשלו: ['הוא ביקשלו', 'וביקש לו', 'הוא ביקש שלא', 'הוא קשה לו', 'וביקשלו'],
  "וגו'": ['וגו', 'וגומר'],
  ודאשתמש: ['הוא דהשתמש'],
  ובסיכה: ['ובשיחה'],
  ודלא: ['הוא דלא', 'אודלה', 'דלא'],
  ויהי: ['והיא'],
  וכל: ['וכל', 'וחול'],
  ומסרה: ['משרה'],
  ועוקרתו: ['הוקרתו', 'באוקרתו'],
  והוי: ['והבי', 'והביי', 'והבה', 'והווה'],
  חטא: ['ח'],
  חם: ['חום'],
  יהוה: ['אדני', 'השם', 'אדונוי', 'אדוני'],
  יליף: ['ילף'],
  יצרך: ['היא צריכה', 'היה צריכה', 'צריכה'],
  ישבעת: ['ישבעת', 'ישבעת', 'ישבעת', 'ישבעת', "שווה'"],
  כבחמורה: ['קבע חמורה'],
  כרך: ['כך'],
  כסא: ['כיסה', 'חיסה'],
  כרחך: ['קור חכה', 'קורחחה', 'קורחחה', 'כוחך'],
  לכשאפנה: ['לך תפנה', 'ליך תפנה', 'לך שיפנה'],
  לפני: ['לפי'],
  לרבן: ['לרבן'],
  ליראת: ['לעירת', 'להירת'],
  מגיתו: ['מגיטו', 'מגטו', 'מקיטו'],
  מועטין: ['מואטין', 'מועטים'],
  מן: ['מין'],
  מקח: ['מכך'],
  מרובין: ['מרובים'],
  מסרוה: ['משרוע'],
  מתן: ['מת'],
  משוא: ['מסוא', 'מסור', 'מסו', 'מסוק'],
  נשאת: ['ניסית', 'ניסת', 'נסית', 'נסעת'],
  סוכו: ['סוחו'],
  עולה: ['אבלה', 'עבלה'],
  עזאי: ['עזיי'],
  עמה: ['אמא', 'אימה'],
  עמל: ['המייל', 'וחול', 'עמל', 'אמל', 'אמיל'],
  עמלים: ['עמלים'],
  עצלים: ['אצילים', 'הצלים'],
  על: ['ועל', 'אל'],
  קבל: ['קיבל'],
  קטלא: ['קטע לה', 'קטע לחייב', 'קטנה חייב'],
  רעהו: ['ראהו'],
  רשאין: ['רשעין', 'רשעים'],
  שוא: ['שוא'],
  שיבור: ['שיבור', 'שבור', 'שברור'],
  שכרן: ['סחרן'],
  שלא: ['שלו'],
  שניים: ['שיניים'],
  שהכל: ['שהקול'],
  תעש: ['תעס']
};

/**
 * The written forms of the Divine Name, as they appear in the text.
 *
 * Metsudah keeps full nikud, so the Name arrives pointed and in several
 * pointings. They are all the same word for our purposes, so the reader is
 * matched against DIVINE_NAME_READINGS whichever pointing the text uses.
 *
 * Entries may be written with or without nikud: they are normalised the same
 * way the text and the child's speech are, so the two sides always meet.
 */
export const DIVINE_NAME_WRITTEN_FORMS: string[] = [
  'יְהוָה',
  'יְהֹוָה',
  'יְהוִה',
  'יְהֹוִה',
  'יֱהוִה',
  'יֱהֹוִה',
  'יהוה',
  "ה'",
  'יי',
];

/**
 * How a child may say the Name out loud. Any of these counts as a correct
 * reading of any written form above, at the position it was read.
 *
 * Add a reading here and it takes effect everywhere. This is the list.
 */
export const DIVINE_NAME_READINGS: string[] = [
  'אדוני',
  'אדני',
  'אדונוי',
  'השם',
  'ה',
];

/**
 * Words whose written form differs from how they are said aloud, beyond the
 * Divine Name. Same rule: any reading counts at the position it was read.
 */
export const SACRED_READINGS: Record<string, string[]> = {
  אלהים: ['אלוקים', 'אלוהים'],
  אלהי: ['אלוקי', 'אלוקיי'],
  אלהיו: ['אלוקיו'],
  אלהינו: ['אלוקינו'],
  אלהיך: ['אלוקיך'],
  אלהיכם: ['אלוקיכם'],
  // The same words in full spelling, which is how the Siddur and the male
  // Tanakh text write them. The reader says אלוקים either way.
  אלוהים: ['אלוקים', 'אלהים'],
  אלוהי: ['אלוקי', 'אלוקיי'],
  אלוהיו: ['אלוקיו'],
  אלוהינו: ['אלוקינו'],
  אלוהיך: ['אלוקיך'],
  אלוהיכם: ['אלוקיכם'],
  // The other names on the whitelist (divine_names_whitelist.xlsx), as said aloud.
  יה: ['קה'],
  הללויה: ['הללוקה'],
  אלוה: ['אלוקה'],
  אל: ['קל'],
  שדי: ['שקי'],
  צבאות: ['צבקות'],
  אהיה: ['אקיה'],
};

/**
 * Elohim with any ending (אלהיהם, אלהיכן, אלהיה...), in either spelling, is said
 * with a kuf. The yud after the root keeps אלה (these) and names like אלקנה out.
 */
const ELOHIM = /^אלו?ה(?=י)/;

/** אֲדֹנָי יְהוִה: after אדני, the Name is said Elokim, not Adonai a second time. */
const NAME_AFTER_ADONAI = ['אלוהים', 'אלוקים'];

/**
 * The one-letter words that attach to the front of a noun: ו, ל, ב, כ, מ, ש, ה.
 *
 * They matter here because a prefix changes how the Name is written. The yud
 * carries a shva on its own, לַיהֹוָה puts the vowel on the prefix and leaves
 * the yud bare, so the word no longer matches any spelling in the list above.
 * A reader saying לַאדוני was marked wrong, and when the Name was the last
 * word of a unit the reader waited for a word that could never arrive.
 */
const HEBREW_PREFIXES = 'ולבכמשה';

const BARE_DIVINE_NAMES = new Set(
  DIVINE_NAME_WRITTEN_FORMS.map((form) => form.replace(/[^א-ת]/g, '')).filter(Boolean),
);

/**
 * How this written word may be said aloud, or undefined if it is an ordinary
 * word. `bare` is the word reduced to its Hebrew letters.
 *
 * A prefix is carried through to the readings rather than ignored: ליהוה
 * offers לאדוני and להשם, not אדוני, so a reader who drops the prefix is
 * still marked on it. Up to two prefix letters (וּבַיהוה, וְלֵאלֹהִים).
 *
 * `previousBare` is the word before it on the page, for אדני יהוה.
 */
export function readingsForBareWord(bare: string, previousBare?: string): string[] | undefined {
  for (let p = 0; p <= 2 && p < bare.length; p++) {
    const prefix = bare.slice(0, p);
    if (![...prefix].every((letter) => HEBREW_PREFIXES.includes(letter))) break;
    const readings = readingsForRoot(bare.slice(p), previousBare);
    if (readings) return readings.map((reading) => prefix + reading);
  }
  return undefined;
}

function readingsForRoot(root: string, previousBare?: string): string[] | undefined {
  if (BARE_DIVINE_NAMES.has(root)) {
    const afterAdonai = previousBare !== undefined && previousBare.replace(/^[ולבכמשה]{0,2}/, '') === 'אדני';
    return afterAdonai && root === 'יהוה' ? [...NAME_AFTER_ADONAI, ...DIVINE_NAME_READINGS] : DIVINE_NAME_READINGS;
  }
  const own = SACRED_READINGS[root];
  if (own) return own;
  if (ELOHIM.test(root)) {
    const rest = root.replace(ELOHIM, '');
    return ['אלוק' + rest, 'אלוה' + rest, 'אלה' + rest];
  }
  return undefined;
}
